import React from 'react';
import { Phone, MapPin, ShieldCheck, Clock } from 'lucide-react';
import { IITH, SERIF } from '@/pages/landing/iithBrand';

/** Helpful campus care info for patients. */
export default function PatientCareTips({ branding = {} }) {
  const phone = branding.phone || 'Reception desk';
  const address = branding.address || IITH.campus;

  return (
    <section
      className="mb-6 grid grid-cols-1 sm:grid-cols-2 gap-3"
      data-testid="patient-care-tips"
    >
      <div className="rounded-2xl border border-[#D5DEE8] bg-[#F8FAFC] p-4">
        <h3 className="text-sm font-bold text-[#071B34] mb-2" style={{ fontFamily: SERIF }}>Campus care tips</h3>
        <ul className="space-y-2 text-[12px] text-[#5A6B7C]">
          <li className="flex gap-2"><Clock className="h-3.5 w-3.5 shrink-0 mt-0.5 text-[#F15A22]" /> Arrive a little early — triage issues your queue number.</li>
          <li className="flex gap-2"><ShieldCheck className="h-3.5 w-3.5 shrink-0 mt-0.5 text-[#F15A22]" /> Keep your patient number handy for reception & pharmacy.</li>
          <li className="flex gap-2"><ShieldCheck className="h-3.5 w-3.5 shrink-0 mt-0.5 text-[#F15A22]" /> Out-station referrals need FIC approval before the letter is issued.</li>
        </ul>
      </div>
      <div className="rounded-2xl border border-[#D5DEE8] bg-white p-4">
        <h3 className="text-sm font-bold text-[#071B34] mb-2" style={{ fontFamily: SERIF }}>Need help?</h3>
        <p className="text-[12px] text-[#5A6B7C] flex items-start gap-2">
          <Phone className="h-3.5 w-3.5 shrink-0 mt-0.5" /> {phone}
        </p>
        <p className="text-[12px] text-[#5A6B7C] flex items-start gap-2 mt-2">
          <MapPin className="h-3.5 w-3.5 shrink-0 mt-0.5" /> {address}
        </p>
        <p className="mt-3 text-[11px] text-[#9AADBE]">{IITH.tagline}</p>
      </div>
    </section>
  );
}
